import { z } from 'zod';
import { api } from '@shared/api';

const connectionSchema = z.object({
  data: z.object({
    status: z.enum(['not_checked', 'not_configured', 'connected', 'failed']),
    store: z.object({ name: z.string().nullable(), domain: z.string() }).nullable(),
    checkedAt: z.iso.datetime().nullable(),
    capabilities: z.object({
      inventoryRead: z.enum(['not_checked', 'available', 'missing']),
    }),
  }),
});

export type ShopifyConnection = z.infer<typeof connectionSchema>['data'];

export async function getShopifyConnection(signal: AbortSignal): Promise<ShopifyConnection> {
  const response = await api.get('/api/v1/integration-connections/shopify', { signal });
  return connectionSchema.parse(response).data;
}

export async function testShopifyConnection(signal: AbortSignal): Promise<ShopifyConnection> {
  const response = await api.post('/api/v1/integration-connections/shopify/test', undefined, {
    signal,
    timeout: 20_000,
  });
  return connectionSchema.parse(response).data;
}
